import React, {useEffect, useState} from "react";
import {ReactComponent as CurrentStep} from "../../../assets/ProductPageIcons/CurrentStep.svg";
import {ReactComponent as IbuttonIcon} from "../../../assets/ProductPageIcons/IbuttonIcon.svg";
import {ReactComponent as NextStep} from "../../../assets/ProductPageIcons/NextStep.svg";
import {ReactComponent as CompletedStep} from "../../../assets/ProductPageIcons/CompletedStep.svg";
import {ReactComponent as StepsLine} from "../../../assets/ProductPageIcons/StepsLine.svg";
import radioActiveBtn from "../../../assets/ProductPageIcons/radioActiveBtn.svg";
import radioBtn from "../../../assets/ProductPageIcons/radioBtn.svg";
import InfoIcon from "../../../assets/ProductPageIcons/InfoIcon.svg";
import greenDot from "../../../assets/ProductPageIcons/greenDot.svg";
import crossIcon from "../../../assets/ProductPageIcons/crosIcon.svg";
// import eth_icon from "../../assets/ETH_ICON.png";
import checkoutCom from "../../../assets/ProductPageIcons/checkoutCom.svg";
import coin_icon from "../../../assets/ProductPageIcons/coin_icon.svg";
import ProfileIcon from "../../../assets/ProductPageIcons/ProfileIcon.svg";
import EmailIcon from "../../../assets/ProductPageIcons/EmailIcon.svg";
import clearicon from "../../../assets/ProductPageIcons/clearicon.svg";
import ContactNumber from "../../../assets/ProductPageIcons/ContactNumber.svg";
import {ReactComponent as ArrowIcon} from "../../../assets/ProductPageIcons/ArrowIcon.svg";

import {capitalizeWords, dollarUS} from "../../../utils/helpers/string";
import {Backdrop, Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select} from "@mui/material";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import CustomLoadingButton from "../../../pages/Product/HelpersComponents/CustomLoadingButton";
import {applyCouponCode, stripePaymentInitV4} from "../../../utils/helpers/APIs/CheckoutPageAPI";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import naceIcon from "../../../assets/ProductPageIcons/nace_favicon.png";
import nuevi from "../../../assets/ProductPageIcons/nuevi.svg";
import usdt_icon from "../../../assets/ProductPageIcons/USDT_ICON.png";
import eth_icon from "../../../assets/ProductPageIcons/ETH_ICON.png";
import CheckSolidGreenIcon from "../../../assets/ProductPageIcons/CheckSolidGreen.svg";
import playStore from "../../../assets/PaymentIcons/google-play.svg";
import apple from "../../../assets/PaymentIcons/apple.svg";
import diners from "../../../assets/PaymentIcons/diners.svg";
import mastercard from "../../../assets/PaymentIcons/mastercard.svg";
import visa from "../../../assets/PaymentIcons/visa.svg";

import "./CheckoutSection.scss";

const PayoutTypeSelector = ({payout_type, selectedPayoutType, setSelectedPayoutType}) => {
  const [showInfo, setShowInfo] = useState(null);

  const handleMouseLeave = () => {
    setShowInfo(null);
  };

  return (
    <div className="payoutType">
      <div className="account_balance_header">
        <h2>Payout Type</h2>
      </div>
      <div className="payoutType_main">
        {payout_type?.map((payoutType, index) => {
          const isActive = payoutType.value === selectedPayoutType;

          return (
            <label
              key={payoutType.value}
              htmlFor={`payout-${payoutType.value}`}
              className={isActive ? "active_payout" : ""}
              onClick={() => setSelectedPayoutType(payoutType.value)}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={isActive ? radioActiveBtn : radioBtn}
                alt={isActive ? "Selected" : "Not Selected"}
              />
              <p>{payoutType.name}</p>
              <input
                type="radio"
                name="payoutType"
                id={`payout-${payoutType.value}`}
                checked={isActive}
                onChange={() => {}} // To silence React warning
              />
              <img
                src={InfoIcon}
                alt="Info"
                className="info-icon"
                onMouseEnter={() => setShowInfo(index)}
              />

              {showInfo === index && (
                <div className="payout_tooltip-box">
                  <p>
                    {payoutType.value === 1 ? "Payout option fixed every 14 days cycle" : "Payout requests on demand, anytime, once 2 requirements are met "}
                    {payoutType.value === 2 && (
                      <a
                        href="https://help.alphacapitalgroup.uk/en/articles/10102634-performance-fee-on-demand"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (learn more)
                      </a>
                    )}
                  </p>
                </div>
              )}
            </label>
          );
        })}
      </div>
    </div>
  );
};

const CheckoutSection = ({challenges, selectedPlanId}) => {
  const [firstStepVisible, setFirstStepVisible] = useState(true);
  const [selectedStep, setStep] = useState(2);
  const [fundingEval, setFundingEval] = useState(false);
  const [selectedType, setSelectedtype] = useState(0);
  const [hoveredChallenge, setHoveredChallenge] = useState(null);
  const [tenPercentProfit, setTenPercentProfit] = useState(1);
  const [selectedAmountBox, setSelectedAmountBox] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState("50");
  const [accountBalance, setAccountBalance] = useState(false);
  const [selectedAmountFree, setSelectedAmountFree] = useState(0);
  const [countryCheck, setCountryCheck] = useState("");
  const [platformVal, setPlatformVal] = useState("MT 5");
  const [selectedPlatformBox, setSelectedPlatformBox] = useState(0);
  const [FreeTrial, setFreeTrial] = useState(false);
  const [openCryptoOptionsBD, setOpenCryptoOptionsBD] = useState(false);
  const [isCoindMethodSelected, setIsCoinMethodSelected] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("ETH");
  const radioGroupRef = React.useRef(null);
  const [paymentMethod, setPaymentMethod] = useState("nuvei");
  const [selectedAcType, setSelectedAcType] = useState(1);
  const [useEA, setUseEA] = useState(0);
  const [basicDetails, setBasicDetails] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [initialPlan, setInitialPlan] = useState();
  const [selectedChallengeDetails, setSelectedChallengeDetails] = useState(null);
  const [selectedPayoutType, setSelectedPayoutType] = useState(selectedChallengeDetails && selectedChallengeDetails[0]?.payout_type);
  const [couponValue, setCouponValue] = useState("");
  const [showTNC, setShowTNC] = useState(false);
  const [TNC, setTNC] = useState(false);
  const [countryCode, setCountryCode] = useState(null);
  const [confirmPaymentClick, setConfirmPaymentClick] = useState(false);
  const [challengePrice, setChallengePrice] = useState(null);
  const [couponCodeExist, setCouponCodeExist] = useState(false);

  const selectedPlan = challenges;

  console.log(selectedPlanId);
  function findObjectById(data, selectedPlanId) {
    for (const key in data) {
      if (Array.isArray(data[key])) {
        for (const plan of data[key]) {
          if (plan.id === selectedPlanId) {
            return plan;
          }
        }
      }
    }
    return null; // Return null if no matching ID is found
  }

  console.log("challenges", selectedPlanId);

  const result = findObjectById(challenges, selectedPlanId);

  // Popup states
  const [showPopup, setShowPopup] = useState(false);
  const [combinedPUHead, setCombinedPUHead] = useState("");
  const [combinedPUBody, setCombinedPUBody] = useState("");
  const [popUpType, setPopUpType] = useState("");

  const [checkout, setCheckout] = useState({
    price: 0,
    discount: 0,
    final_price: 0,
  });

  const [data, setData] = useState({
    email: "",
    confirmEmail: "",
    firstName: "",
    lastName: "",
    // pwd: "",
    contact: "",
  });

  const [validEmail, setValidEmail] = useState(false);
  const [validConfirmEmail, setValidConfirmEmail] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    // Validate email
    if (emailRegex.test(data.email.trim())) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  }, [data.email]);

  useEffect(() => {
    // Validate email and check if email and confirm email match
    if (emailRegex.test(data.confirmEmail.trim()) && data.email.trim() === data.confirmEmail.trim()) {
      setValidConfirmEmail(true);
    } else {
      setValidConfirmEmail(false);
    }
  }, [data.confirmEmail, data.email]);

  const [coupon, setCoupon] = useState({
    value: "",
    error: "",
    loading: false,
  });
  const [isChecked, setIsChecked] = useState({
    tnc: false,
    not_us_resident: false,
    acknowledge_personal_data: false,
    agree_to_news_letters: false,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const updateData = (k, v) => setData((prevState) => ({...prevState, [k]: v}));

  const platform = ["MT 5", "C Trader", "DX Trade"];
  const ac_type = ["Raw spread", "No commission"];
  const EA = ["Yes", "No"];
  const payout_type = [
    {
      name: "Bi-Weekly",
      value: 1,
    },
    {
      name: "On demand",
      value: 2,
    },
  ];

  const filteredPlatforms = countryCheck && countryCheck === "US" ? ["DX Trade"] : platform;

  const STEPS = [1, 2, 3];

  const currentChallenge = selectedChallengeDetails && selectedChallengeDetails[0];

  useEffect(() => {
    if (tenPercentProfit === 1) {
      setChallengePrice(currentChallenge?.price_alpha_pro_10per);
    } else {
      setChallengePrice(currentChallenge?.Price);
    }
  }, [data?.challenge_id, currentChallenge, fundingEval, tenPercentProfit]);

  useEffect(() => {
    if (fundingEval) {
      setTenPercentProfit(0);
    }
  }, [fundingEval]);

  const handleMouseEnter = (challenge) => {
    setHoveredChallenge(challenge); // Set hovered challenge
  };

  const handleMouseLeave = () => {
    setHoveredChallenge(null); // Clear hovered challenge
  };

  function handlePaymentMethod(e) {
    const id = e.currentTarget.id;
    setPaymentMethod(id);
    if (id === "coinspayment") {
      setOpenCryptoOptionsBD(true);
    }
  }
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev); // Properly toggle dropdown state
  };

  const handleTNCModal = (value) => {
    setShowTNC(TNC ? false : value);
  };

  const handleFinalPayment = async (e) => {
    e.preventDefault();

    setConfirmPaymentClick(true);

    // Validate required fields
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(data.email.trim())) {
      showToast("Please enter a valid email address");
      setConfirmPaymentClick(false);
      return;
    }

    if (!data?.firstName || !data?.lastName) {
      showToast("Please enter your full name!", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!emailRegex.test(data.confirmEmail.trim())) {
      showToast("Please enter a valid confirm email address");
      setConfirmPaymentClick(false);
      return;
    }

    if (!validConfirmEmail) {
      showToast("Email address does not match.");
      setConfirmPaymentClick(false);
      return;
    }

    if (isChecked.tnc === false || isChecked.acknowledge_personal_data === false || (platformVal !== "DX Trade" && countryCheck !== "US" && !isChecked.not_us_resident)) {
      showToast("Please accept the terms and conditions", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!data.challenge_id) {
      showToast("Please select a plan and balance!", "error");
      setConfirmPaymentClick(false);
      return;
    }

    // Prepare payloads
    const country_code = (countryCode && countryCode.code) || "";
    const acc_creation_payload = {
      name: data.name,
      pwd: data.pwd,
      pwdInvestor: data.pwd,
      leverage: data.leverage,
      challenge: data.challenge,
      payout_type: selectedPayoutType,
      EAs: useEA,
      ten_percent_profit_target: tenPercentProfit,
      raw_spread: selectedAcType === 0,
      email: data.email,
      platform: countryCheck === "US" ? "dxtrade" : selectedPlatformBox === 0 ? "mt5" : selectedPlatformBox === 1 ? "ctrader" : "dxtrade",
      agreed_to: [
        isChecked.tnc && "I declare that I have read and agree with Terms & Conditions, Privacy policy, General Service Agreement.",
        isChecked.not_us_resident && "I'm not a US resident or citizen.",
        isChecked.acknowledge_personal_data &&
          "I acknowledge that signing up with personal details that do not match my ID/Password information, will lead to suspension of my payout(s) and closure of my account(s).",
        isChecked.agree_to_news_letters && "I agree to receive newsletters, news, and product updates.",
      ].filter(Boolean),
      // country_code,
    };

    const payload = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      contact: data.contact,
      // country_code,
      challenge_id: data.challenge_id,
      payment_method: paymentMethod,
      cryptocurrency: selectedCrypto,
      ten_percent_profit_target: tenPercentProfit,
      payout_type: selectedPayoutType,
      EAs: useEA,
      raw_spread: selectedAcType === 0,
      platform: countryCheck === "US" ? "dxtrade" : selectedPlatformBox === 0 ? "mt5" : selectedPlatformBox === 1 ? "ctrader" : "dxtrade",
    };

    if (coupon.value && !coupon.loading) {
      payload["coupon"] = coupon.value;
    }

    try {
      // Perform payment initialization with Axios
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined) {
          formData.append(key, value);
        }
      });

      const {data: result} = await axios.post("https://backend.alphacapitalgroup.uk/v2/get/checkout/payment-url/", formData);

      if (result?.url) {
        console.log("Redirecting to payment URL:", result.url);

        // Redirect to the provided URL
        window.location.href = result.url;
      } else {
        throw new Error("Redirect URL not found");
      }

      if (result.auth) {
        console.log("User authenticated:", result.auth);
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      setConfirmPaymentClick(false);
      console.error("Payment initialization failed:", error);

      let errorMessage = "Something went wrong";

      if (error?.response) {
        const {data} = error.response;

        if (data?.detail) {
          errorMessage = data?.detail;
        } else if (data?.message) {
          errorMessage = data?.message;
        } else if (Array?.isArray(data) && data?.length > 0) {
          // Handle array response like ["Contact number already registered"]
          errorMessage = data[0]; // Take the first error message from the array
        } else if (data && Object?.keys(data)?.length > 0) {
          const firstKey = Object?.keys(data)[0];
          errorMessage = Array?.isArray(data[firstKey]) ? data[firstKey][0] : data[firstKey];
        }
      } else if (error?.request) {
        errorMessage = "Something went wrong";
      } else {
        errorMessage = error?.message || "Failed to initialize payment.";
      }

      showToast(errorMessage, "error");
    }
  };

  const showToast = (message, type = "info") => {
    setConfirmPaymentClick(false);
    if (toast[type]) {
      toast[type](message, {
        // position: toast.POSITION.TOP_CENTER,
        autoClose: 5000, // Auto close after 5 seconds
      });
    } else {
      console.error(`Invalid toast type: ${type}`);
    }
  };

  const [buttonSpinner, setButtonSpinner] = useState(false);

  const validateCouponCode = async () => {
    setCoupon((prevState) => ({...prevState, loading: true}));

    // if (!data?.challenge_id) {
    //   console.error("Invalid challenge ID");
    //   setCoupon((prevState) => ({...prevState, error: "Invalid challenge ID", loading: false}));
    //   return;
    // }

    const coupon_code = coupon?.value || null;

    try {
      setButtonSpinner(true);

      const res = await applyCouponCode(data?.challenge_id, coupon_code, tenPercentProfit);

      setButtonSpinner(false);

      setCoupon((prevState) => ({...prevState, error: "", loading: false}));
      setCouponValue(coupon_code);
      setCouponCodeExist(true);

      setCheckout((prev) => ({
        price: res.actual_price,
        discount: coupon.error ? 0 : res.discount,
        final_price: coupon.error ? res.actual_price : res.discounted_price,
      }));

      setFreeTrial(res.discounted_price === 0);

      if (res.data?.coupon) {
        setCoupon(res.data.coupon);
      }
    } catch (error) {
      setButtonSpinner(false);
      const errorMessage = error?.detail || "An error occurred while applying the coupon.";
      setCoupon((prevState) => ({
        ...prevState,
        error: errorMessage,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    if (platformVal === `DX Trade`) {
      setIsChecked({...isChecked, not_us_resident: false});
    }
  }, [platformVal]);

  useEffect(() => {
    const countryCheckingReq = async () => {
      try {
        let url = `check/country/`;
        const {data, status} = await "https://backend.alphacapitalgroup.uk".get(url);

        if (status < 399) {
          setCountryCheck(data?.country);
        }
      } catch (error) {
        console.log(error.response?.data || error.message);
        // throw error.response?.data || error.message;
      }
    };

    countryCheckingReq();
  }, []);

  // useEffect(() => {
  //   challenges &&
  //     Object.keys(challenges).forEach((plan_type) => {
  //       challenges[plan_type].forEach((challenge) => {
  //         // setFundingEval(challenge.plan_type === "Alpha pro" ? "Alpha Pro" : challenge.plan_type);
  //         setAccountBalance(challenge.account_balance);
  //         setStep(challenge.steps);
  //         updateData("leverage", Number(challenge.leverage));
  //         updateData("challenge_id", challenge.id);
  //         updateData("challenge", challenge.id);

  //         return;
  //       });
  //     });
  // }, [challenges, dispatch]);

  // useEffect(() => {
  //   if (challenges) {
  //     setInitialPlan(challenges["Alpha Pro"]?.find((item) => item?.id === Number(result?.id))?.Price);
  //   }
  // }, []);

  // By default select account type when change in steps
  useEffect(() => {
    if (selectedStep && typeof challenges === "object") {
      const plans = Object.keys(challenges).filter((item) => (challenges[item].filter((itm) => itm.steps === selectedStep && !String(item).toLowerCase().includes("free")).length && item) || false);

      if (result) {
        setFundingEval(String(capitalizeWords(result?.plan_type)));
      } else {
        setFundingEval((plans.length && plans[0]) || null);
      }
    }
  }, [selectedStep, challenges, result, couponValue]);

  useEffect(() => {
    if (result) {
      setStep(result.steps);
      setFundingEval(String(capitalizeWords(result?.plan_type)));
      updateData("challenge_id", Number(selectedPlanId));
      updateData("challenge", Number(selectedPlanId));
      setAccountBalance(result?.account_balance);

      // setAccountBalance(result.account_balance);
    }
  }, [selectedPlanId, result, challenges]);

  useEffect(() => {
    updateData("challenge_id", 8);
    setFundingEval("Alpha Pro");
    setAccountBalance(challenges["Alpha Pro"]?.[1]?.account_balance);
  }, []);

  useEffect(() => {
    if (couponValue) {
      validateCouponCode();
    }
  }, [couponValue, tenPercentProfit, data?.challenge_id]);

  useEffect(() => {
    setSelectedPayoutType(selectedChallengeDetails && selectedChallengeDetails[0]?.payout_type);
  }, [selectedChallengeDetails]);

  useEffect(() => {
    if (fundingEval && challenges) {
      // Get the list of valid challenges for the current fundingEval
      const validChallenges = challenges[fundingEval] || [];

      // Set accountBalance to a default valid option if it doesn't match the current fundingEval options
      if (validChallenges.length > 0) {
        const isBalanceValid = validChallenges.some((challenge) => challenge?.account_balance === accountBalance);

        if (!isBalanceValid) {
          // Set accountBalance to the first valid option for this fundingEval
          setAccountBalance(validChallenges[0].account_balance);
          return; // Exit early to re-run effect with updated accountBalance
        }
      }

      // Proceed with existing logic for filtering and updating selectedChallengeDetails
      const plan = validChallenges.filter((challenge) => challenge?.account_balance === accountBalance);

      setSelectedChallengeDetails(plan);

      if (plan.length === 1) {
        updateData("leverage", Number(plan[0].leverage));
        updateData("challenge_id", plan[0].id);
        updateData("challenge", plan[0].id);
      } else {
        updateData("challenge_id", "");
        updateData("challenge", "");
      }
    }
  }, [fundingEval, accountBalance, selectedStep, challenges, selectedPrice, selectedAmountFree]);

  console.log("fundingEval", fundingEval);

  return (
    <div className="WPPublicCheckoutPage_main">
      <div className="WPPublicCheckoutPage_main_header">
        <h4>Product</h4>
        <h2>
          Become an <span>Alpha Trader</span>
        </h2>
      </div>

      {/* {anonymous ? (
        <div className="WPCheckoutPage_main_header_container">
          <h6>Products</h6>
          <h2>
            Become an <span className="gradient_header">Alpha Traders</span>
          </h2>
          <p>
            Choose the evaluation based on your preference to become an Alpha
            Trader.
          </p>
        </div>
      ) : (
        false
      )} */}

      {/* <div
        style={{ cursor: "pointer" }}
        className="backBtnContainer"
        onClick={() => navigate("/dashboard")}
      >
        <img style={{ width: "20px" }} src={backBtn} alt="backBtn" />
        Back
      </div> */}
      <div className="WPCheckoutPage_left_right_sec">
        <div className="account_balance">
          <div>
            <div className={`account_balance_inner ${firstStepVisible ? "firstStepVisible" : ""}`}>
              <div className="step_progress_container">
                <div className="stepProgress_heading">
                  <h3>Select Plan</h3>
                  <h3>Basic Info</h3>
                </div>
                <div className="stepProgress">
                  <div
                    className="firstProgress"
                    onClick={() => setFirstStepVisible(!firstStepVisible)}
                  >
                    {firstStepVisible ? <CurrentStep /> : <CompletedStep />}
                  </div>

                  <div className="progressLine">
                    <StepsLine />
                  </div>
                  <div
                    className="nextProgress"
                    onClick={() => setFirstStepVisible(!firstStepVisible)}
                  >
                    {firstStepVisible ? <NextStep /> : <CurrentStep />}
                  </div>
                </div>
              </div>

              <div className="checkoutContent">
                <div className="firstStep">
                  <div className="platform">
                    <div className="heading">
                      <h1
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        Step
                      </h1>
                    </div>
                    <div className="platform_main">
                      {STEPS.map((step) => (
                        <label
                          onClick={(e) => {
                            setStep(step);
                          }}
                          className={"platform_box " + (selectedStep === step && "active_label selected_box")}
                        >
                          {selectedStep === step ? (
                            <img
                              src={radioActiveBtn}
                              alt="radioActiveBtn"
                            />
                          ) : (
                            <img
                              src={radioBtn}
                              alt="radioBtn"
                            />
                          )}
                          <p>{step} Step</p>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="user_ac_type">
                    <div className="account_balance_header">
                      <h2>Account Type</h2>
                    </div>
                    <div className="user_ac_type_inner">
                      {challenges &&
                        Object.keys(challenges).map((challenge, i) => {
                          // Check if it's a public checkout page

                          if (challenge === "Free Trial") {
                            return null;
                          }
                          if (!challenges[challenge] || challenges[challenge].length === 0) {
                            return null;
                          }
                          if (!challenges[challenge].filter((item) => item.steps === selectedStep).length) {
                            return null;
                          }
                          return (
                            <label
                              htmlFor={challenge}
                              key={i}
                              className={String(fundingEval)?.toLowerCase() === challenge?.toLowerCase() ? "ac_type_option active_label" : "ac_type_option"}
                              onClick={() => setSelectedtype(i)}
                            >
                              <div className="label_inner_div">
                                {String(fundingEval)?.toLowerCase() === challenge?.toLowerCase() ? (
                                  <img
                                    src={radioActiveBtn}
                                    alt="radioActiveBtn"
                                  />
                                ) : (
                                  <img
                                    src={radioBtn}
                                    alt="radioBtn"
                                  />
                                )}

                                <p>{challenge}</p>

                                <input
                                  type="radio"
                                  id={challenge}
                                  name="fundingEval"
                                  value={challenge}
                                  checked={String(fundingEval)?.toLowerCase() === challenge?.toLowerCase()}
                                  onChange={(e) => setFundingEval(capitalizeWords(e.target.value) === "alpha pro" ? "Alpha Pro" : capitalizeWords(e.target.value))}
                                  // disabled={removeCoupon}
                                />
                              </div>

                              <img
                                src={InfoIcon}
                                alt="InfoIcon"
                                onMouseEnter={() => handleMouseEnter(challenge)}
                                onMouseLeave={handleMouseLeave}
                              />

                              {hoveredChallenge === challenge && (
                                <div className="tooltip-box">
                                  <div className={`dropdown-content open`}>
                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        <p>Leverage</p>
                                      </div>
                                      <div>
                                        <h4>{challenges[challenge]?.[0]?.Leverage ? `1:${challenges[challenge]?.[0]?.Leverage}` : "-"}</h4>
                                      </div>
                                    </div>
                                    {/* Add more dropdown content like this */}
                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        <p>Profit Target 1</p>
                                      </div>
                                      <div>
                                        <h4>
                                          {tenPercentProfit && challenges[challenge]?.[0]?.plan_type === "Alpha pro"
                                            ? "10.00%"
                                            : challenges[challenge]?.[0]?.Evaluation_Phase_1 && challenges[challenge]?.[0]?.account_balance
                                            ? `${((challenges[challenge]?.[0]?.Evaluation_Phase_1 / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                            : "-"}
                                        </h4>
                                      </div>
                                    </div>

                                    {challenges[challenge]?.[0]?.Evaluation_Phase_2 > 0 && (
                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Profit Target 2</p>
                                        </div>
                                        <div>
                                          <h4>
                                            {challenges[challenge]?.[0]?.Evaluation_Phase_2 && challenges[challenge]?.[0]?.account_balance
                                              ? `${((challenges[challenge]?.[0]?.Evaluation_Phase_2 / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                              : "-"}
                                          </h4>
                                        </div>
                                      </div>
                                    )}

                                    {challenges[challenge]?.[0]?.Evaluation_Phase_3 > 0 && (
                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Profit Target 3</p>
                                        </div>
                                        <div>
                                          <h4>
                                            {challenges[challenge]?.[0]?.Evaluation_Phase_3 && challenges[challenge]?.[0]?.account_balance
                                              ? `${((challenges[challenge]?.[0]?.Evaluation_Phase_3 / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                              : "-"}
                                          </h4>
                                        </div>
                                      </div>
                                    )}

                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        {fundingEval === "Alpha One" ? <p>Trailing MLL</p> : <p>Max Loss</p>}
                                      </div>
                                      <div>
                                        <h4>
                                          {fundingEval === "Alpha One" && currentChallenge?.trailing_mll !== 0
                                            ? `${currentChallenge?.trailing_mll}%`
                                            : challenges[challenge]?.[0]?.Max_Loss && challenges[challenge]?.[0]?.account_balance
                                            ? `${((challenges[challenge]?.[0]?.Max_Loss / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                            : "-"}
                                        </h4>
                                      </div>
                                    </div>

                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        <p>Max Daily Loss</p>
                                      </div>
                                      <div>
                                        <h4>
                                          {challenges[challenge]?.[0]?.Max_Daily_Loss && challenges[challenge]?.[0]?.account_balance
                                            ? `${((challenges[challenge]?.[0]?.Max_Daily_Loss / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                            : "-"}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        <p>Profit Split</p>
                                      </div>
                                      <div>
                                        <h4>{challenges[challenge]?.[0]?.Profit_Split ? challenges[challenge]?.[0]?.Profit_Split + "%" : "-"}</h4>
                                      </div>
                                    </div>
                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        {selectedPayoutType === 1 ? <p>Bi Weekly Profit Split</p> : <p>On Demand Payout</p>}
                                      </div>
                                      <div>
                                        <h4>{challenges[challenge]?.[0]?.Bi_Weekly_Profit_Split ? "Yes" : "No"}</h4>
                                      </div>
                                    </div>
                                    <div className="dropdown-content_inner">
                                      <div>
                                        <img
                                          src={greenDot}
                                          alt="greenDot"
                                        />
                                        <p>Max Capital growth</p>
                                      </div>
                                      <div>
                                        <h4>{dollarUS(challenges[challenge]?.[0]?.Max_Capital_Growth || 0)}</h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </label>
                          );
                        })}
                    </div>
                  </div>

                  {fundingEval === "Alpha Pro" && (
                    <div className="platform">
                      <div className="heading">
                        <h1
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          Phase 1 profit target
                        </h1>
                        {/* <p style={{ marginBottom: "35px" }}>
                      Choose profit target for the challenge
                    </p> */}
                      </div>
                      <div className="platform_main">
                        <label
                          onClick={(e) => {
                            setTenPercentProfit(0);
                          }}
                          className={"platform_box " + (!tenPercentProfit && " active_label selected_box")}
                        >
                          {!tenPercentProfit ? (
                            <img
                              src={radioActiveBtn}
                              alt="radioActiveBtn"
                            />
                          ) : (
                            <img
                              src={radioBtn}
                              alt="radioBtn"
                            />
                          )}
                          <p>8%</p>
                        </label>

                        <label
                          onClick={(e) => {
                            setTenPercentProfit(1);
                          }}
                          className={tenPercentProfit ? "platform_box active_label selected_box" : "platform_box"}
                        >
                          {tenPercentProfit ? (
                            <img
                              src={radioActiveBtn}
                              alt="radioActiveBtn"
                            />
                          ) : (
                            <img
                              src={radioBtn}
                              alt="radioBtn"
                            />
                          )}
                          <p>10%</p>
                        </label>
                      </div>
                    </div>
                  )}

                  <div className="accountSize">
                    <div className="account_balance_header">
                      <h2>Account size</h2>
                    </div>

                    {fundingEval === "Alpha Pro" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha Pro" in challenges &&
                          challenges["Alpha Pro"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      updateData("challenge_id", balance.id);
                                      // setSelectedChallengeDetails(balance);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}

                    {fundingEval === "Free Trial" && (
                      <div className="amount_list">
                        {challenges["Free Trial"]?.map((balance, index) => {
                          return (
                            <label
                              htmlFor={balance.amount}
                              className={
                                // selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                              }
                              // style={{
                              //   border:
                              //     selectedAmountFree === index
                              //       ? "1px solid #1395DC"
                              //       : "border: 1px solid var(--Box-Stroke-Gradient, rgba(184, 230, 255, 0.07))",
                              // }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "10px",
                                }}
                              >
                                {
                                  // selectedPrice === balance.Price ||
                                  data?.challenge_id === balance?.id ? (
                                    <img
                                      src={radioActiveBtn}
                                      alt="radioActiveBtn"
                                    />
                                  ) : (
                                    <img
                                      src={radioBtn}
                                      alt="radioBtn"
                                    />
                                  )
                                }
                                <input
                                  type="radio"
                                  name="accoun_balance_value"
                                  id={balance.amount}
                                  onClick={(e) => {
                                    setSelectedAmountFree(e.target.checked ? index : null);
                                    setSelectedPrice(balance.amount);
                                    updateData("challenge_id", balance.id);
                                  }}
                                  onChange={(e) => setAccountBalance(balance.account_balance)}
                                  value={accountBalance}
                                  style={{display: "none"}}
                                />
                                <p>{dollarUS(balance.account_balance || 0)}</p>
                              </div>
                              {/* <p
                            className={
                              selectedAmountFree === index
                                ? "active_amount_value"
                                : "normal_amount_value"
                            }
                          >
                            {index === selectedAmountFree
                              ? dollarUS(balance.Price)
                              : dollarUS(balance.Price)}
                          </p> */}
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {fundingEval === "Swing" && (
                      <div className="amount_list">
                        {challenges["Swing"]?.map((balance, index) => {
                          return (
                            <label
                              htmlFor={balance.amount}
                              className={
                                // selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                              }
                              // style={{
                              //   border:
                              //     selectedAmountFree === index
                              //       ? "1px solid #1395DC"
                              //       : "border: 1px solid var(--Box-Stroke-Gradient, rgba(184, 230, 255, 0.07))",
                              // }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "10px",
                                }}
                              >
                                {
                                  // selectedPrice === balance.Price ||
                                  data?.challenge_id === balance?.id ? (
                                    <img
                                      src={radioActiveBtn}
                                      alt="radioActiveBtn"
                                    />
                                  ) : (
                                    <img
                                      src={radioBtn}
                                      alt="radioBtn"
                                    />
                                  )
                                }
                                <input
                                  type="radio"
                                  name="accoun_balance_value"
                                  id={balance.amount}
                                  onClick={(e) => {
                                    setSelectedAmountFree(e.target.checked ? index : null);
                                    setSelectedPrice(balance.amount);
                                    updateData("challenge_id", balance.id);
                                  }}
                                  onChange={(e) => setAccountBalance(balance.account_balance)}
                                  value={accountBalance}
                                  style={{display: "none"}}
                                />
                                <p>{dollarUS(balance?.account_balance || 0)}</p>
                              </div>
                              {/* <p
                            className={
                              selectedAmountFree === index
                                ? "active_amount_value"
                                : "normal_amount_value"
                            }
                          >
                            {index === selectedAmountFree
                              ? dollarUS(balance.Price)
                              : dollarUS(balance.Price)}
                          </p> */}
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {fundingEval === "Alpha Pro Plus" && (
                      <div className="amount_list">
                        {challenges["Alpha Pro Plus"]?.map((balance, index) => {
                          return (
                            <label
                              htmlFor={balance.amount}
                              className={
                                // selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                              }
                              // style={{
                              //   border:
                              //     selectedAmountFree === index
                              //       ? "1px solid #1395DC"
                              //       : "border: 1px solid var(--Box-Stroke-Gradient, rgba(184, 230, 255, 0.07))",
                              // }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "10px",
                                }}
                              >
                                {
                                  // selectedPrice === balance.Price ||
                                  data?.challenge_id === balance?.id ? (
                                    <img
                                      src={radioActiveBtn}
                                      alt="radioActiveBtn"
                                    />
                                  ) : (
                                    <img
                                      src={radioBtn}
                                      alt="radioBtn"
                                    />
                                  )
                                }
                                <input
                                  type="radio"
                                  name="accoun_balance_value"
                                  id={balance.amount}
                                  onClick={(e) => {
                                    setSelectedAmountFree(e.target.checked ? index : null);
                                    setSelectedPrice(balance.amount);
                                    updateData("challenge_id", balance.id);
                                  }}
                                  onChange={(e) => setAccountBalance(balance.account_balance)}
                                  value={accountBalance}
                                  style={{display: "none"}}
                                />
                                <p>{dollarUS(balance?.account_balance || 0)}</p>
                              </div>
                              {/* <p
                            className={
                              selectedAmountFree === index
                                ? "active_amount_value"
                                : "normal_amount_value"
                            }
                          >
                            {index === selectedAmountFree
                              ? dollarUS(balance.Price)
                              : dollarUS(balance.Price)}
                          </p> */}
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {fundingEval === "Alpha One" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha One" in challenges &&
                          challenges["Alpha One"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      // setSelectedChallengeDetails(balance);
                                      updateData("challenge_id", balance.id);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}

                    {fundingEval === "Alpha X" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha X" in challenges &&
                          challenges["Alpha X"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      // setSelectedChallengeDetails(balance);
                                      updateData("challenge_id", balance.id);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}

                    {fundingEval === "Alpha Three" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha Three" in challenges &&
                          challenges["Alpha Three"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      // setSelectedChallengeDetails(balance);
                                      updateData("challenge_id", balance.id);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}
                  </div>

                  <div className="platform">
                    <div className="account_balance_header">
                      <h2>Platform</h2>
                    </div>
                    <div className="platform_main">
                      {filteredPlatforms?.map((platform, index) => {
                        if (selectedStep === 1 && platform === "DX Trade") return null;
                        if (selectedStep === 3 && platform === "DX Trade") return null;
                        return (
                          <label
                            htmlFor={index}
                            className={index === selectedPlatformBox ? "platform_box active_label selected_box" : "platform_box"}
                            onClick={(e) => {
                              if ((FreeTrial || fundingEval === "Free Trial") && index === 1) return;
                              setSelectedPlatformBox(index);
                              setPlatformVal(platform);
                            }}
                            // style={{
                            //   border:
                            //     index === selectedPlatformBox
                            //       ? "1px solid #1395DC"
                            //       : "1px solid rgba(255, 255, 255, 0.09)",
                            // }}
                          >
                            {index === selectedPlatformBox ? (
                              <img
                                src={radioActiveBtn}
                                alt="radioActiveBtn"
                              />
                            ) : (
                              <img
                                src={radioBtn}
                                alt="radioBtn"
                              />
                            )}
                            <p>{platform}</p>
                            {/* {index === 2 ? (
                  <div style={{display:'flex',alignItems:'center',gap:'10px'}} disabled>
                    <img src={matchTrade} width='60px' style={{borderRadius:'50%'}}  alt="" />
                    <h5>MatchTrader</h5>
                  </div>
                  
                ) : (
                  <img
                    src={platform}
                    alt=""
                    style={{
                      filter:
                        index === 1 &&
                        (FreeTrial || fundingEval === "Free Trial")
                          ? "blur(3px)"
                          : "",
                    }}
                  />
                )} */}
                            <input
                              type="radio"
                              name="platform_type"
                              id={index}
                              checked={selectedPlatformBox === index}
                              disabled={index === 1 && (FreeTrial || fundingEval === "Free Trial")}
                              style={{
                                filter: index === 1 && (FreeTrial || fundingEval === "Free Trial") ? "blur(3px)" : "",
                              }}
                            />
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="secondStep">
                  <div className="confirm_order">
                    <div className="account_balance_header">
                      <h2>Payment Method</h2>
                    </div>
                    <div className="order_option">
                      <div
                        className="paymentMethodSelectorBox"
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "15px",
                          flexWrap: "wrap",
                        }}
                      >
                        <Dialog
                          sx={{
                            "& .MuiDialog-paper": {
                              width: "80%",
                              maxHeight: 435,
                              background: "#08131F",
                              borderRadius: "16px",
                              border: "1px solid #808080b5",
                            },
                          }}
                          maxWidth="xs"
                          // TransitionProps={{ onEntering: handleEntering }}
                          open={openCryptoOptionsBD}
                          // onClick={(e) => setOpenCryptoOptionsBD(false)}
                        >
                          <DialogTitle sx={{backgroundColor: "#01030c", color: "#fff"}}>Select Coin Payment method</DialogTitle>
                          <DialogContent
                            dividers
                            sx={{backgroundColor: "#01030c", color: "#fff"}}
                          >
                            {/* <RadioGroup
                    ref={radioGroupRef}
                    aria-label="crypto currencies"
                    name="cryptocurrency"
                    value={selectedCrypto}
                    onChange={(event) => {
                      setSelectedCrypto(event.target.value);
                    }}
                  >
                    {[
                      { label: "ETH", value: "ETH", icon: eth_icon },
                      { label: "USDT", value: "USDT.ERC20", usdt_icon },
                    ].map(({ label, value, icon }) => (
                      <FormControlLabel
                        label={label}
                        value={value}
                        key={value}
                        control={<Radio />}
                        sx={{
                          direction: "flex",
                          alignItems: "center",
                          gap: "20px",
                          height: "94px",
                          padding: "15px 20px",
                          border: "1px solid rgba(255, 255, 255, 0.09)",
                          marginBottom: "10px",
                          borderRadius: "10px",
                          flexDirection: "row-reverse",
                          justifyContent: "space-between",
                        }}
                      />
                    ))}
                  </RadioGroup> */}

                            <div className="options">
                              <div className="options_coins">
                                <div className="heading">
                                  <h1>Select Coin Payment method</h1>
                                  <img
                                    src={crossIcon}
                                    onClick={() => {
                                      setIsCoinMethodSelected(false);
                                      setOpenCryptoOptionsBD(false);
                                    }}
                                    alt="close modal"
                                  />
                                </div>
                                <div className="option_wrapper">
                                  {[
                                    {
                                      label: "USDT-TRON",
                                      value: "USDT.TRC20",
                                      icon: "https://cryptologos.cc/logos/tron-trx-logo.png?v=029",
                                      netWorkType: "NETWORK-TRON",
                                    },
                                    {
                                      label: "USDC-TRON",
                                      value: "USDC.TRC20",
                                      icon: "https://cryptologos.cc/logos/tron-trx-logo.png?v=029",
                                      netWorkType: "NETWORK-TRON",
                                    },
                                    {
                                      label: "COIN-ETH",
                                      value: "ETH",
                                      icon: eth_icon,
                                      netWorkType: "NETWORK-ETH",
                                    },
                                    {
                                      label: "COIN-USDT",
                                      value: "USDT.ERC20",
                                      icon: usdt_icon,
                                      netWorkType: "NETWORK-ETH",
                                    },
                                    {
                                      label: "COIN-USDC",
                                      value: "USDC",
                                      icon: "https://cryptologos.cc/logos/usd-coin-usdc-logo.png?v=029",
                                      netWorkType: "NETWORK-ETH",
                                    },
                                  ]?.map(({label, value, icon, netWorkType}) => {
                                    return (
                                      <label
                                        htmlFor={label}
                                        className={value === selectedCrypto ? "optionC active_label selected_coin_method" : "optionC"}
                                        key={value}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            // paddingTop: "20px",
                                          }}
                                          className="coin-payment-methods"
                                        >
                                          <img
                                            src={icon}
                                            alt=""
                                            width="10%"
                                            className="coin_icon"
                                          />
                                          <p>{label}</p>
                                        </div>
                                        <div className="coinMethonEnd">
                                          <input
                                            type="radio"
                                            name="coin"
                                            id={label}
                                            ref={radioGroupRef}
                                            value={value}
                                            checked={value === selectedCrypto ? true : false}
                                            onChange={(event) => {
                                              setSelectedCrypto(event.target.value);
                                            }}
                                          />
                                          <p>{netWorkType}</p>
                                        </div>
                                      </label>
                                    );
                                  })}
                                </div>

                                <button
                                  className="confirm_btn"
                                  onClick={() => setOpenCryptoOptionsBD(false)}
                                >
                                  Confirm
                                </button>
                              </div>
                            </div>

                            <button className="confrim_btn">Confirm</button>
                          </DialogContent>
                        </Dialog>

                        <div
                          id="nuvei"
                          className="paymentMethods"
                          onClick={handlePaymentMethod}
                          style={paymentMethod === "nuvei" ? {border: "1px solid #0d56eb"} : {border: "1px solid #b8e6ff12"}}
                        >
                          <label
                            htmlFor="nuvei-radio"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "213px",
                              justifyContent: "space-between",
                            }}
                            className={`${paymentMethod === "nuvei" ? "payments-active_new active_label" : ""}`}
                          >
                            <div
                              className="payment-logo-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              {paymentMethod === "nuvei" ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img
                                  src={radioBtn}
                                  alt="radioBtn"
                                />
                              )}
                              <input
                                type="radio"
                                id="nuvei-radio"
                                checked={paymentMethod === "nuvei"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "20px",
                                }}
                              >
                                <p>Nuvei</p>
                              </div>
                            </div>
                            <img
                              src={nuevi}
                              style={{height: "23px", width: "23px"}}
                              alt=""
                              className="payment-logo"
                            />
                          </label>

                          <div className="combined_payments">
                            <img
                              src={mastercard}
                              alt="mastercard"
                            />
                            <img
                              src={visa}
                              alt="visa"
                            />
                            {/* <img
                              src={diners}
                              alt="diners"
                            /> */}
                            <img
                              src={apple}
                              alt="apple"
                            />
                            <img
                              src={playStore}
                              alt="playStore"
                            />
                          </div>
                        </div>
                        {/* <div
                          id="nacepayment"
                          className="paymentMethods"
                          onClick={handlePaymentMethod}
                        >
                          <label
                            htmlFor="nace-radio"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "213px",
                              justifyContent: "space-between",
                            }}
                            className={`${
                              paymentMethod === "nacepayment"
                                ? "payments-active_new active_label"
                                : ""
                            }`}
                          >
                            <div
                              className="payment-logo-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              {paymentMethod === "nacepayment" ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img src={radioBtn} alt="radioBtn" />
                              )}
                              <input
                                type="radio"
                                id="nace-radio"
                                checked={paymentMethod === "nacepayment"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "20px",
                                }}
                              >
                                <p>Nace</p>
                              </div>
                            </div>
                            <img
                              src={naceIcon}
                              style={{ height: "23px", width: "23px" }}
                              alt=""
                              className="payment-logo"
                            />
                          </label>
                        </div> */}
                        <div
                          id="coinspayment"
                          className="paymentMethods"
                          onClick={handlePaymentMethod}
                          // style={{background: "#070a12"}}
                        >
                          <label
                            htmlFor="coinspayment-radio"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "213px",
                              justifyContent: "space-between",
                            }}
                            className={` ${paymentMethod === "coinspayment" ? "payments-active_new active_label" : ""}`}
                          >
                            <div
                              className="payment-logo-container coinspayment-logo-container"
                              style={{
                                display: "flex",
                                // flexDirection: "column",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              {paymentMethod === "coinspayment" ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img
                                  src={radioBtn}
                                  alt="radioBtn"
                                />
                              )}
                              <input
                                type="radio"
                                id="coinspayment-radio"
                                checked={paymentMethod === "coinspayment"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "20px",
                                }}
                              >
                                <p>CoinPayments</p>
                              </div>
                            </div>
                            <img
                              src={coin_icon}
                              alt=""
                              className="payment-logo coinspayment-logo"
                            />
                          </label>

                          {/* {paymentMethod === "coinspayment" ? <span></span> : <></>} */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {selectedStep != 1 && (
                    <PayoutTypeSelector
                      payout_type={payout_type}
                      selectedPayoutType={selectedPayoutType}
                      setSelectedPayoutType={setSelectedPayoutType}
                    />
                  )}

                  {/* <div className="payoutType">
                    <div className="account_balance_header">
                      <h2>Payout Type</h2>
                    </div>
                    <div className="payoutType_main">
                      {payout_type?.map((payoutType) => {
                        const isActive =
                          payoutType.value === selectedPayoutType;

                        return (
                          <label
                            key={payoutType.value}
                            htmlFor={`payout-${payoutType.value}`}
                            className={isActive ? "active_payout" : ""}
                            onClick={() =>
                              setSelectedPayoutType(payoutType.value)
                            }
                          >
                            <img
                              src={isActive ? radioActiveBtn : radioBtn}
                              alt={isActive ? "Selected" : "Not Selected"}
                            />
                            <p>{payoutType.name}</p>
                            <input
                              type="radio"
                              name="payoutType"
                              id={`payout-${payoutType.value}`}
                              checked={isActive}
                              disabled={isActive}
                            />
                          </label>
                        );
                      })}
                    </div>
                  </div> */}

                  <div className="commission_EA_use">
                    <div className="commission">
                      <div className="account_balance_header">
                        <h2>Commission</h2>
                      </div>

                      <div className="commission_inner">
                        {ac_type?.map((type, index) => {
                          return (
                            <label
                              htmlFor={type}
                              onClick={(e) => {
                                setSelectedAcType(index);
                              }}
                              className={selectedAcType === index ? "platform_box active_label selected_box" : "platform_box"}
                              // style={{
                              //   border:
                              //     selectedAcType === index
                              //       ? "1px solid #1395DC"
                              //       : "1px solid rgba(255, 255, 255, 0.09)",
                              // }}
                            >
                              {selectedAcType === index ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img
                                  src={radioBtn}
                                  alt="radioBtn"
                                />
                              )}

                              <p>{type}</p>
                              <input
                                type="radio"
                                name="platform"
                                id={type}
                                checked={selectedAcType === index}
                                // disabled
                              />
                            </label>
                          );
                        })}
                      </div>
                    </div>

                    {selectedPlatformBox !== 1 && selectedPlatformBox !== 2 ? (
                      <div className="EA_use">
                        <div className="account_balance_header">
                          <h2>EA use</h2>
                        </div>

                        <div className="EA_use_inner">
                          <div
                            onClick={(e) => {
                              setUseEA(true);
                            }}
                            className={useEA ? "platform_box active_label" : "platform_box"}
                            // style={{
                            //   border: useEA
                            //     ? "1px solid #1395DC"
                            //     : "1px solid rgba(255, 255, 255, 0.09)",
                            // }}
                          >
                            {useEA ? (
                              <img
                                src={radioActiveBtn}
                                alt="radioActiveBtn"
                              />
                            ) : (
                              <img
                                src={radioBtn}
                                alt="radioBtn"
                              />
                            )}

                            <p>Yes</p>
                          </div>

                          <div
                            onClick={(e) => {
                              setUseEA(false);
                            }}
                            className={"platform_box " + (!useEA && "active_label selected_box")}
                            // style={{
                            //   border: !useEA
                            //     ? "1px solid #1395DC"
                            //     : "1px solid rgba(255, 255, 255, 0.09)",
                            // }}
                          >
                            {!useEA ? (
                              <img
                                src={radioActiveBtn}
                                alt="radioActiveBtn"
                              />
                            ) : (
                              <img
                                src={radioBtn}
                                alt="radioBtn"
                              />
                            )}
                            <p>No</p>
                          </div>
                        </div>

                        {/* {EA?.map((EA_text, index) => {
            return (
              <label
                htmlFor={EA_text + index}
                className={
                  useEA === index ? "platform_box selected_box" : "platform_box"
                }
              >
                <p>{EA_text}</p>
                <input
                  type="radio"
                  name="EA"
                  id={EA_text + index}
                  onClick={(e) => {
                    setUseEA(e.target.checked ? index : null);
                  }}
                  // disabled={index === 0}
                />
              </label>
            );
          })} */}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="custom_info">
                    <div className="account_balance_header">
                      <h2>Customer Information</h2>
                    </div>
                    <div className="custom_info_inner">
                      <div style={{marginRight: "2px"}}>
                        <img
                          src={ProfileIcon}
                          alt="ProfileIcon"
                        />
                        <input
                          size="small"
                          placeholder="First Name *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                          }}
                          value={data ? data?.firstName : ""}
                          onChange={(e) => updateData("firstName", e.target.value)}
                        />
                      </div>

                      <div style={{marginRight: "2px"}}>
                        <img
                          src={ProfileIcon}
                          alt="ProfileIcon"
                        />

                        <input
                          size="small"
                          placeholder="Last Name *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                          }}
                          value={data ? data?.lastName : ""}
                          onChange={(e) => updateData("lastName", e.target.value)}
                        />
                      </div>

                      <div style={{marginRight: "2px"}}>
                        <img
                          src={EmailIcon}
                          alt="EmailIcon"
                        />
                        <input
                          size="small"
                          placeholder="Email *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                          }}
                          defaultValue={basicDetails ? basicDetails.email : ""}
                          value={data.email}
                          onChange={(e) => updateData("email", e.target.value)}
                          onPaste={(e) => e.preventDefault()}
                        />
                        {validEmail && (
                          <>
                            <img
                              src={CheckSolidGreenIcon}
                              alt="CheckSolidGreenIcon"
                            />
                          </>
                        )}
                      </div>
                      <div style={{marginRight: "2px"}}>
                        <img
                          src={EmailIcon}
                          alt="EmailIcon"
                        />
                        <input
                          size="small"
                          placeholder="Confirm Email *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                            background: "transparent",
                          }}
                          defaultValue={basicDetails ? basicDetails.confirmEmail : ""}
                          value={data.confirmEmail}
                          onChange={(e) => updateData("confirmEmail", e.target.value)}
                          onPaste={(e) => e.preventDefault()}
                        />
                        {validConfirmEmail && (
                          <>
                            <img
                              src={CheckSolidGreenIcon}
                              alt="CheckSolidGreenIcon"
                            />
                          </>
                        )}
                      </div>

                      <div style={{marginRight: "2px", marginBottom: "2px"}}>
                        <img
                          src={ContactNumber}
                          alt="Contact_number"
                        />
                        <input
                          size="small"
                          placeholder="Contact Number"
                          fullWidth
                          type="text"
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                            appearance: "textfield",
                          }}
                          value={data?.contact}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numeric input and enforce a max length of 15
                            if (/^\d*$/.test(value) && value.length <= 15) {
                              updateData("contact", value);
                            }
                          }}
                        />
                      </div>

                      {/* <div>
                    <img src={ContactNumber} alt="Password" />
                    <input
                      size="small"
                      placeholder="Password"
                      fullWidth
                      style={{
                        border: "1px solid rgb(255 255 255 / 33%);",
                        borderRadius: "10px",
                        background: "none !important",
                      }}
                      value={data?.pwd}
                      onChange={(e) => updateData("pwd", e.target.value)}
                    />
                  </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="nextBtn">
                <button
                  className={firstStepVisible ? "btnNext" : "BtnBack"}
                  onClick={() => setFirstStepVisible(!firstStepVisible)}
                >
                  {firstStepVisible ? "Next" : "Back"} <ArrowIcon />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="customer_inforamtion">
          <div className="billingInfoTop">
            <div className="checkout_info_inner">
              <h2>Account Type</h2>
              <h3 className="planInfoBtn">
                {fundingEval}
                <button
                  className="dropdown-container_btn"
                  onMouseEnter={toggleDropdown}
                  onMouseLeave={() => setIsOpen(false)}
                >
                  <IbuttonIcon className={isOpen ? "" : ""} />
                  {isOpen && (
                    <div
                      className="dropdown-content open"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Leverage</p>
                        </div>
                        <div>
                          <h4>1:{currentChallenge?.Leverage}</h4>
                        </div>
                      </div>
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Profit Target 1</p>
                        </div>
                        <div>
                          <h4>{tenPercentProfit && fundingEval === "Alpha Pro" ? dollarUS((currentChallenge?.account_balance * 10) / 100) : dollarUS(currentChallenge?.Evaluation_Phase_1)}</h4>
                        </div>
                      </div>

                      {currentChallenge?.Evaluation_Phase_2 > 0 && (
                        <div className="dropdown-content_inner">
                          <div>
                            <img
                              src={greenDot}
                              alt="greenDot"
                            />
                            <p>Profit Target 2</p>
                          </div>
                          <div>
                            <h4>{dollarUS(currentChallenge?.Evaluation_Phase_2)}</h4>
                          </div>
                        </div>
                      )}

                      {currentChallenge?.Evaluation_Phase_3 > 0 && (
                        <div className="dropdown-content_inner">
                          <div>
                            <img
                              src={greenDot}
                              alt="greenDot"
                            />
                            <p>Profit Target 3</p>
                          </div>
                          <div>
                            <h4>{dollarUS(currentChallenge?.Evaluation_Phase_3)}</h4>
                          </div>
                        </div>
                      )}

                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          {fundingEval === "Alpha One" ? <p>Trailing MLL</p> : <p>Max Loss</p>}
                        </div>
                        <div>
                          <h4>{fundingEval === "Alpha One" && currentChallenge?.trailing_mll !== 0 ? `${currentChallenge?.trailing_mll}%` : dollarUS(currentChallenge?.Max_Loss)}</h4>
                        </div>
                      </div>
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Max Daily Loss</p>
                        </div>
                        <div>
                          <h4>{dollarUS(currentChallenge?.Max_Daily_Loss)}</h4>
                        </div>
                      </div>
                      {fundingEval !== "Free Trial" && (
                        <div className="dropdown-content_inner">
                          <div>
                            <img
                              src={greenDot}
                              alt="greenDot"
                            />
                            <p>Profit Split</p>
                          </div>
                          <div>
                            <h4>{currentChallenge?.Profit_Split === "N/A" ? "-" : `${currentChallenge?.Profit_Split}%`}</h4>
                          </div>
                        </div>
                      )}
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          {selectedPayoutType === 1 ? <p>Bi Weekly Profit Split</p> : <p>On Demand Payout</p>}
                        </div>
                        <div>
                          <h4>{currentChallenge?.Bi_Weekly_Profit_Split ? "Yes" : "No"}</h4>
                        </div>
                      </div>
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Max Capital growth</p>
                        </div>
                        <div>
                          <h4>{dollarUS(currentChallenge?.Max_Capital_Growth) || "-"}</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </button>
              </h3>
            </div>
            <div className="checkout_info_inner">
              <h2>Step</h2>
              <h3>{selectedStep}</h3>
            </div>
            <div className="checkout_info_inner">
              <h2>Account Size</h2>
              <h3>{dollarUS(accountBalance || 0)}</h3>
            </div>
            <div className="checkout_info_inner">
              <h2>Platform</h2>
              <h3>{platformVal}</h3>
            </div>
          </div>

          <div onClick={toggleDropdown}>
            {/* <button className="see_more">
              <h2>{isOpen ? fundingEval : <p>See More</p>}</h2>
              <img
                src={dropdownArrow}
                alt="dropdownArrow"
                className={`${isOpen ? "dropdownArrow_rotate" : ""}`}
              />
            </button> */}
          </div>

          <div className="discount">
            {fundingEval === "Free Trial" ? (
              ""
            ) : (
              <>
                {" "}
                <h2>Discount</h2>
                <div className="couponLine">
                  <div className="inputHolder discount_input">
                    <input
                      className="discount_input"
                      placeholder="Enter Coupon Code"
                      type="text"
                      value={coupon.value}
                      // disabled={Number(checkout.final_price) === 0 ? true : false}
                      onBlur={(e) => validateCouponCode()}
                      onChange={(e) =>
                        setCoupon((prevState) => ({
                          ...prevState,
                          value: e.target.value,
                        }))
                      }
                      style={coupon.error ? {border: "2px solid #fd2d2d"} : {}}
                      disabled={couponValue ? true : false}
                    />
                    {coupon.error ? (
                      <small
                        style={{
                          color: "#fd2d2d",
                          textAlign: "left",
                          float: "left",
                          fontFamily: "sans-serif",
                        }}
                      >
                        {coupon?.error}
                      </small>
                    ) : (
                      <></>
                    )}
                    <button
                      onClick={validateCouponCode}
                      className={couponValue ? "applied" : ""}
                      disabled={couponValue || buttonSpinner}
                    >
                      {buttonSpinner ? (
                        <CircularProgress
                          size={14}
                          style={{color: "white"}}
                        />
                      ) : couponValue ? (
                        "Applied"
                      ) : (
                        "Apply Code"
                      )}
                    </button>
                  </div>
                  {couponValue ? (
                    <div className="couponValue">
                      <p>{couponValue}</p>
                      <img
                        src={clearicon}
                        alt="clearicon"
                        onClick={() => {
                          setCoupon({value: "", error: false});
                          setCouponValue(null);
                          setCheckout((prevState) => ({
                            ...prevState,
                            discount: 0,
                            final_price: prevState.price,
                          }));
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}

            <div className="calculate_price_with_discount">
              <div>
                <h2>{fundingEval}</h2>

                {/* <p>${dollarUS(accountBalance)}</p> */}
                <p>{dollarUS(challengePrice || 0)} </p>
              </div>
              {/* {checkout?.discount > 0 ? (
              <div>
                <h2>Discount</h2>
                <p>{checkout?.discount}</p>
              </div>
            ) : (
              ""
            )} */}

              {checkout?.discount && checkout?.discount !== 0 && !coupon.error ? (
                <div>
                  <h2>Discount</h2>
                  <p>
                    {coupon.error ? "" : "-"} {dollarUS(checkout?.discount)}
                  </p>
                </div>
              ) : null}

              <div className="final_price">
                <p>Total</p>
                <p>
                  {/* {couponValue
                    ? coupon.error
                      ? dollarUS(checkout?.final_price || 0)
                      : dollarUS(checkout?.final_price || 0)
                    : coupon.error
                    ? dollarUS(currentChallenge?.Price || 0)
                    : dollarUS(currentChallenge?.Price || 0)} */}
                  {couponValue ? dollarUS(checkout?.final_price || 0) : dollarUS(challengePrice || 0)}
                </p>
              </div>
            </div>
            <span>By confirming the order:</span>

            <div className="term_and_conditions">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked.tnc}
                    onChange={(e) => setIsChecked({...isChecked, tnc: e.target.checked})}
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={
                  <p>
                    I declare that I have read and agree with
                    <span
                      onClick={() => setShowTNC(true)}
                      style={{color: "#1f69ff", cursor: "pointer"}}
                    >
                      {" "}
                      Terms & Conditions, Privacy Policy, General Service Agreement.*
                    </span>
                  </p>
                }
              />
              {countryCheck === "US" || platformVal === "DX Trade" ? (
                <></>
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      value={isChecked.not_us_resident}
                      onChange={(e) =>
                        setIsChecked({
                          ...isChecked,
                          not_us_resident: e.target.checked,
                        })
                      }
                      sx={{marginTop: "0px", borderRadius: "4px"}}
                    />
                  }
                  label={<p>I'm not a US resident or citizen.*</p>}
                />
              )}

              <FormControlLabel
                control={
                  <Checkbox
                    value={isChecked.acknowledge_personal_data}
                    onChange={(e) =>
                      setIsChecked({
                        ...isChecked,
                        acknowledge_personal_data: e.target.checked,
                      })
                    }
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={<p>I acknowledge that signing up with personal details that do not match my ID/Password information, will lead to suspension of my payout(s) and closure of my account(s).*</p>}
              />
              <div className="privacy_policy_box">
                {/* <h2>Privacy Policy</h2> */}
                <p>
                  Thank you for choosing to be part of our community at Alpha Capital Group Limited (“Company,” “we,” “us,” or “our”). We are committed to protecting your personal information and your
                  right to privacy. If you have any questions or concerns about this privacy notice or our practices with regard to your personal information, please contact us at
                  accounts@alphacapitalgroup.uk.
                </p>
                <p>
                  This privacy notice describes how we might use your information if you:
                  <br />
                  Visit our website at http://www.alphacapitalgroup.uk
                  <br />
                  Engage with us in other related ways ― including any sales, marketing, or events
                </p>
                <p>
                  In this privacy notice, if we refer to:
                  <br />
                  “Website,” we are referring to any website of ours that references or links to this policy
                </p>
                <p>“Services,” we are referring to our Website, and other related services, including any sales, marketing, or events</p>
                <p>
                  The purpose of this privacy notice is to explain to you in the clearest way possible what information we collect, how we use it, and what rights you have in relation to it. If there
                  are any terms in this privacy notice that you do not agree with, please discontinue use of our Services immediately.
                </p>
                <p>Please read this privacy notice carefully, as it will help you understand what we do with the information that we collect.</p>

                <h3>WHAT INFORMATION DO WE COLLECT?</h3>
                <p>Personal information you disclose to us</p>
                <p>In Short: We collect personal information that you provide to us.</p>
                <p>
                  We collect personal information that you voluntarily provide to us when you register on the Website, express an interest in obtaining information about us or our products and
                  Services, when you participate in activities on the Website or otherwise when you contact us.
                </p>
                <p>
                  The personal information that we collect depends on the context of your interactions with us and the Website, the choices you make and the products and features you use. The personal
                  information we collect may include the following:
                </p>
                <p>Personal Information Provided by You. We collect names; phone numbers; email addresses; mailing addresses; contact preferences; and other similar information.</p>
                <p>
                  Payment Data. We may collect data necessary to process your payment if you make purchases, such as your payment instrument number (such as a credit card number), and the security
                  code associated with your payment instrument. All payment data is stored by Stripe . You may find their privacy notice link(s) here: https://stripe.com/gb/privacy.
                </p>
                <p>All personal information that you provide to us must be true, complete and accurate, and you must notify us of any changes to such personal information.</p>
                <p>Information automatically collected</p>
                <p>In Short: Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics — is collected automatically when you visit our Website.</p>
                <p>
                  We automatically collect certain information when you visit, use or navigate the Website. This information does not reveal your specific identity (like your name or contact
                  information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device
                  name, country, location, information about how and when you use our Website and other technical information. This information is primarily needed to maintain the security and
                  operation of our Website, and for our internal analytics and reporting purposes.
                </p>
                <p>The information we collect includes:</p>
                <p>
                  Log and Usage Data. Log and usage data is service-related, diagnostic, usage and performance information our servers automatically collect when you access or use our Website and
                  which we record in log files. Depending on how you interact with us, this log data may include your IP address, device information, browser type and settings and information about
                  your activity in the Website (such as the date/time stamps associated with your usage, pages and files viewed, searches and other actions you take such as which features you use),
                  device event information (such as system activity, error reports (sometimes called ‘crash dumps’) and hardware settings). Location Data. We collect location data such as information
                  about your device’s location, which can be either precise or imprecise. How much information we collect depends on the type and settings of the device you use to access the Website.
                  For example, we may use GPS and other technologies to collect geolocation data that tells us your current location (based on your IP address). You can opt out of allowing us to
                  collect this information either by refusing access to the information or by disabling your Location setting on your device. Note however, if you choose to opt out, you may not be
                  able to use certain aspects of the Services.
                </p>

                <h3>HOW DO WE USE YOUR INFORMATION?</h3>
                <p>
                  In Short: We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or
                  your consent.
                </p>
                <p>
                  We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our
                  legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations. We indicate the specific
                  processing grounds we rely on next to each purpose listed below.
                </p>
                <p>We use the information we collect or receive:</p>
                <p>
                  To facilitate account creation and logon process. If you choose to link your account with us to a third-party account (such as your Google or Facebook account), we use the
                  information you allowed us to collect from those third parties to facilitate account creation and logon process for the performance of the contract. To post testimonials. We post
                  testimonials on our Website that may contain personal information. Prior to posting a testimonial, we will obtain your consent to use your name and the content of the testimonial. If
                  you wish to update, or delete your testimonial, please contact us at support@alphacapitalgroup.uk and be sure to include your name, testimonial location, and contact information.
                  Request feedback. We may use your information to request feedback and to contact you about your use of our Website. To enable user-to-user communications. We may use your information
                  in order to enable user-to- user communications with each user’s consent.
                  <br />
                  To manage user accounts. We may use your information for the purposes of managing our account and keeping it in working order. To send administrative information to you. We may use
                  your personal information to send you product, service and new feature information and/or information about changes to our terms, conditions, and policies.
                  <br />
                  To protect our Services. We may use your information as part of our efforts to keep our Website safe and secure (for example, for fraud monitoring and prevention).
                  <br />
                  To enforce our terms, conditions and policies for business purposes, to comply with legal and regulatory requirements or in connection with our contract.
                  <br />
                  To respond to legal requests and prevent harm. If we receive a subpoena or other legal request, we may need to inspect the data we hold to determine how to respond.
                  <br />
                  Fulfill and manage your orders. We may use your information to fulfill and manage your orders, payments, returns, and exchanges made through the Website.
                  <br />
                  Administer prize draws and competitions. We may use your information to administer prize draws and competitions when you elect to participate in our competitions.
                  <br />
                  To deliver and facilitate delivery of services to the user. We may use your information to provide you with the requested service.
                  <br />
                  To respond to user inquiries/offer support to users. We may use your information to respond to your inquiries and solve any potential issues you might have with the use of our
                  Services.
                  <br />
                  To send you marketing and promotional communications. We and/or our third-party marketing partners may use the personal information you send to us for our marketing purposes, if this
                  is in accordance with your marketing preferences. For example, when expressing an interest in obtaining information about us or our Website, subscribing to marketing or otherwise
                  contacting us, we will collect personal information from you. You can opt-out of our marketing emails at any time (see the “WHAT ARE YOUR PRIVACY RIGHTS?” below).
                  <br />
                  Deliver targeted advertising to you. We may use your information to develop and display personalized content and advertising (and work with third parties who do so) tailored to your
                  interests and/or location and to measure its effectiveness.
                  <br />
                  For other business purposes. We may use your information for other business purposes, such as data analysis, identifying usage trends, determining the effectiveness of our
                  promotional campaigns and to evaluate and improve our Website, products, marketing and your experience. We may use and store this information in aggregated and anonymized form so
                  that it is not associated with individual end users and does not include personal information.
                </p>

                <h3>WILL YOUR INFORMATION BE SHARED WITH ANYONE?</h3>
                <p>In Short: We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.</p>
                <p>We may process or share your data that we hold based on the following legal basis:</p>
                <p>
                  Consent: We may process your data if you have given us specific consent to use your personal information for a specific purpose.
                  <br />
                  Legitimate Interests: We may process your data when it is reasonably necessary to achieve our legitimate business interests.
                  <br />
                  Performance of a Contract: Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.
                  <br />
                  Legal Obligations: We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court
                  order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements).
                  <br />
                  Vital Interests: We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected
                  fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved. More specifically, we may
                  need to process your data or share your personal information in the following situations:
                </p>
                <p>
                  Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a
                  portion of our business to another company.
                  <br />
                  Vendors, Consultants and Other Third-Party Service Providers. We may share your data with third-party vendors, service providers, contractors or agents who perform services for us or
                  on our behalf and require access to such information to do that work. Examples include: payment processing, data analysis, email delivery, hosting services, customer service and
                  marketing efforts. We may allow selected third parties to use tracking technology on the Website, which will enable them to collect data on our behalf about how you interact with our
                  Website over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content, pages or features, and better understand
                  online activity. Unless described in this notice, we do not share, sell, rent or trade any of your information with third parties for their promotional purposes. We have contracts in
                  place with our data processors, which are designed to help safeguard your personal information. This means that they cannot do anything with your personal information unless we have
                  instructed them to do it. They will also not share your personal information with any organization apart from us. They also commit to protect the data they hold on our behalf and to
                  retain it for the period we instruct.
                  <br />
                  Affiliates. We may share your information with our affiliates, in which case we will require those affiliates to honor this privacy notice. Affiliates include our parent company and
                  any subsidiaries, joint venture partners or other companies that we control or that are under common control with us.
                  <br />
                  Business Partners. We may share your information with our business partners to offer you certain products, services or promotions.
                </p>

                <h3>WHO WILL YOUR INFORMATION BE SHARED WITH?</h3>
                <p>In Short: We only share information with the following categories of third parties.</p>
                <p>
                  We only share and disclose your information with the following categories of third parties. If we have processed your data based on your consent and you wish to revoke your consent,
                  please contact us using the contact details provided in the section below titled “HOW CAN YOU CONTACT US ABOUT THIS NOTICE?”.
                </p>
                <p>
                  Payment Processors
                  <br />
                  Ad Networks
                  <br />
                  Data Analytics Services
                  <br />
                  Finance & Accounting Tools
                  <br />
                  Order Fulfillment Service Provider
                  <br />
                  User Account Registration & Authentication Services
                </p>

                <h3>HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
                <p>In Short: We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.</p>
                <p>
                  We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted
                  by law (such as tax, accounting or other legal requirements). No purpose in this notice will require us keeping your personal information for longer than six (6) months past the
                  termination of the user’s account.
                </p>
                <p>
                  When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example,
                  because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion
                  is possible.
                </p>

                <h3>HOW DO WE KEEP YOUR INFORMATION SAFE?</h3>
                <p>In Short: We aim to protect your personal information through a system of organizational and technical security measures.</p>
                <p>
                  We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our
                  safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot
                  promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security, and improperly collect, access, steal, or modify your
                  information. Although we will do our best to protect your personal information, transmission of personal information to and from our Website is at your own risk. You should only
                  access the Website within a secure environment.
                </p>

                <h3>DO WE COLLECT INFORMATION FROM MINORS?</h3>
                <p>In Short: We do not knowingly collect data from or market to children under 18 years of age.</p>
                <p>
                  We do not knowingly solicit data from or market to children under 18 years of age. By using the Website, you represent that you are at least 18 or that you are the parent or guardian
                  of such a minor and consent to such minor dependent’s use of the Website. If we learn that personal information from users less than 18 years of age has been collected, we will
                  deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18,
                  please contact us at support@alphacapitalgroup.uk.
                </p>

                <h3>WHAT ARE YOUR PRIVACY RIGHTS?</h3>
                <p>
                  In Short: In some regions, such as the European Economic Area (EEA) and United Kingdom (UK), you have rights that allow you greater access to and control over your personal
                  information. You may review, change, or terminate your account at any time.
                </p>
                <p>
                  In some regions (like the EEA and UK), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your
                  personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; and (iv) if applicable, to data portability. In certain
                  circumstances, you may also have the right to object to the processing of your personal information. To make such a request, please use the contact details provided below. We will
                  consider and act upon any request in accordance with applicable data protection laws.
                </p>
                <p>
                  If we are relying on your consent to process your personal information, you have the right to withdraw your consent at any time. Please note however that this will not affect the
                  lawfulness of the processing before its withdrawal, nor will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than
                  consent.
                </p>
                <p>
                  If you are a resident in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection
                  supervisory authority. You can find their contact details here:
                  <br />
                  https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
                </p>
                <p>
                  If you are a resident in Switzerland, the contact details for the data protection authorities are available here:
                  <br />
                  https://www.edoeb.admin.ch/edoeb/en/home.html.
                </p>
                <p>If you have questions or comments about your privacy rights, you may email us at support@alphacapitalgroup.uk.</p>
                <p>Account Information</p>
                <p>If you would at any time like to review or change the information in your account or terminate your account, you can:</p>
                <p>
                  Contact us using the contact information provided.
                  <br /> Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain some information in
                  our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with applicable legal requirements.
                </p>
                <p>
                  Opting out of email marketing: You can unsubscribe from our marketing email list at any time by clicking on the unsubscribe link in the emails that we send or by contacting us using
                  the details provided below. You will then be removed from the marketing email list — however, we may still communicate with you, for example to send you service-related emails that
                  are necessary for the administration and use of your account, to respond to service requests, or for other non-marketing purposes. To otherwise opt-out, you may:
                </p>
                <p>Contact us using the contact information provided.</p>

                <h3>CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
                <p>
                  Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not
                  to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognizing and implementing DNT signals has been
                  finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for
                  online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.
                </p>

                <h3>DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h3>
                <p>In Short: Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.</p>
                <p>
                  California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of
                  charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties
                  with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your
                  request in writing to us using the contact information provided below.
                </p>
                <p>
                  If you are under 18 years of age, reside in California, and have a registered account with the Website, you have the right to request removal of unwanted data that you publicly post
                  on the Website. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a
                  statement that you reside in California. We will make sure the data is not publicly displayed on the Website, but please be aware that the data may not be completely or
                  comprehensively removed from all our systems (e.g. backups, etc.).
                </p>

                <h3>DO WE MAKE UPDATES TO THIS NOTICE?</h3>
                <p>In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.</p>
                <p>
                  We may update this privacy notice from time to time. The updated version will be indicated by an updated “Revised” date and the updated version will be effective as soon as it is
                  accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We
                  encourage you to review this privacy notice frequently to be informed of how we are protecting your information.
                </p>

                <h3>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
                <p>If you have questions or comments about this notice, you may email us at support@alphacapitalgroup.uk or by post to:</p>
                <p>Alpha Capital Group Limited</p>
                <p>
                  10 Lower Thames Street Billingsgate
                  <br />
                  London EC3R 6AF
                </p>
                <p>United Kingdom</p>

                <h3>HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</h3>
                <p>
                  Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you, change that information, or delete it in some
                  circumstances. To request to review, update, or delete your personal information, please submit a request form by clicking here.
                </p>
              </div>
              <FormControlLabel
                control={
                  <Checkbox
                    value={isChecked.agree_to_news_letters}
                    onChange={(e) =>
                      setIsChecked({
                        ...isChecked,
                        agree_to_news_letters: e.target.checked,
                      })
                    }
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={<p>I agree to receive news letters, news and product updates.</p>}
              />
            </div>

            {/* <div className="TandC">
              <input
                type="checkbox"
                value={isChecked.tnc}
                onChange={(e) =>
                  setIsChecked({ ...isChecked, tnc: e.target.checked })
                }
                style={{ marginTop: "3px" }}
              />

              <p>
                I declare that I have read and agree with
                <span
                  onClick={() => setShowTNC(true)}
                  style={{ color: "#1f69ff", cursor: "pointer" }}
                >
                  Terms & Conditions , Privacy policy , General Service
                  Aggrement.*
                </span>
              </p>
            </div> */}

            {/* <div className="TandC">
              <input
                type="checkbox"
                value={isChecked.not_us_resident}
                onChange={(e) =>
                  setIsChecked({
                    ...isChecked,
                    not_us_resident: e.target.checked,
                  })
                }
                style={{ marginTop: "3px" }}
              />

              <p>I'm not a US resident or citizen.*</p>
            </div> */}

            {/* <div className="TandC">
              <input
                type="checkbox"
                value={isChecked.acknowledge_personal_data}
                onChange={(e) =>
                  setIsChecked({
                    ...isChecked,
                    acknowledge_personal_data: e.target.checked,
                  })
                }
                style={{ marginTop: "3px" }}
              />

              <p>
                I acknowledge that signing up with personal details that do not
                match my ID/Password information, will lead to suspension of my
                payout(s) and closure of my account(s).*
              </p>
            </div> */}

            {/* <div className="TandC">
              <input
                type="checkbox"
                value={isChecked.agree_to_news_letters}
                onChange={(e) =>
                  setIsChecked({
                    ...isChecked,
                    agree_to_news_letters: e.target.checked,
                  })
                }
                style={{ marginTop: "3px" }}
              />
              <p>I agree to receive news letters, news and product updates.</p>
            </div> */}
          </div>
          {firstStepVisible === false ? (
            <CustomLoadingButton
              disabled={confirmPaymentClick}
              onClick={handleFinalPayment}
              loading={confirmPaymentClick}
              className="proceed_btn"
              text="Proceed"
              sx={{color: "white"}}
              endIcon={false}
            />
          ) : (
            ""
          )}
        </div>
      </div>

      {isCoindMethodSelected && <CoinPaymentOption setIsCoinMethodSelected={setIsCoinMethodSelected} />}
    </div>
  );
};

export default CheckoutSection;

const CoinPaymentOption = ({setIsCoinMethodSelected}) => {
  const [selectedBox, setSelectedBox] = useState(0);
  const coindPayments = [
    {
      // icon: bitCoinIcon,
      name: "Bitcoins",
    },
    {
      // icon: bitCoinIcon,
      name: "Lorem",
    },
    {
      // icon: bitCoinIcon,
      name: "Lorems",
    },
  ];

  return (
    <div className="options">
      <div className="options_coins">
        <div className="heading">
          <h1>Select Coin Payment method</h1>
          <img
            src={crossIcon}
            onClick={() => setIsCoinMethodSelected(false)}
          />
        </div>
        {coindPayments?.map((option, index) => {
          return (
            <label
              htmlFor={option.name}
              className={selectedBox === index ? "optionC selected_coin_method" : "optionC"}
            >
              <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                <img
                  src={option.icon}
                  alt=""
                />
                <p>{option.name}</p>
              </div>
              <input
                type="radio"
                name="coin"
                id={option.name}
                onClick={(e) => setSelectedBox(e.target.checked ? index : null)}
              />
            </label>
          );
        })}
        <button
          className="confirm_btn"
          onClick={() => setIsCoinMethodSelected(false)}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};
